var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copy-plan-container"},[(_vm.isPageAllowed)?[_c(_vm.currentPages,{ref:_vm.currentPages,tag:"component",attrs:{"page-func-names":_vm.pageFuncNames},on:{"refresh":_vm.refreshPage}})]:[_c('NoPermissionInfo',{staticStyle:{"background-color":"#fff"}},[_c('p',[_vm._v("此页面展示OPPO媒体相关数据内容与广告管理。")])])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }